import React, {useEffect, useRef, useState} from "react";
import {boldTextStyles, regularTextStyles} from "../Style";
import {CheckIcon, CrossIcon, DownloadIcon} from "./common/CarCommonComponents";
import DatePicker from "react-datepicker";
import {FaCalendarAlt} from "react-icons/fa";
import {Form} from "react-bootstrap";
import TooltipTFAF from "./common/TooltipTFAF";
import AdditionalExcess from "./AdditionalExcess";
import SaveEmailQuote from "./SaveEmailQuote";

const ThirdPartyFireTheft = (props) => {

  const [additionalPopUpShow, setAdditionalPopUpShow] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [vehicleValue, setVehicleValue] = useState(props.inputValues.vehicleValue);
  const [errorMessage, setErrorMessage] = useState("");
  const datePickerRef = useRef(null);
  const [isValueButtonEnabled, setIsValueButtonEnabled] = useState(false);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
    ? 'carAutosureEvent'
    : window.location.href.includes('quashed')
      ? 'carQuashedEvent'
      : window.location.href.includes('better')
        ? 'carBetterEvent'
        : window.location.href.includes('simplify')
          ? 'carSimplifyEvent'
          : '';

  const handleNextButtonClick = () => {
    if (!props.inputValues.policyStartDate) {
      props.handleChangeValue('policyStartDate', new Date());
    }
    props.handleChangeValue('declarationPopupShow', true);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Submit',
        'status': 'Success',
        'virtualUrl': `${baseUrl}/vehicle/step3`,
        'pageTitle': 'Quote',
      });

  }

  const handleIconClick = () => {
    // Trigger the DatePicker to open when the icon is clicked
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true); // Open the calendar
    }
  };
  const saveAndEmailQuote = (e) => {
    e.preventDefault();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Email My Quote Start',
        'virtualUrl': `${baseUrl}/vehicle/step3`,
        'pageTitle': 'Quote',
      });
    setShowEmailPopup(true);
  }
  useEffect(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Select Cover Type',
        'categoryDetails': 'Third Party Fire & Theft',
        'virtualUrl': `${baseUrl}/vehicle/step3`,
        'pageTitle': 'Quote',
      });
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const containerStyle = {
    border: "2px solid #1851A3",
    padding: "20px",
    width: "100%",
    maxWidth: "1000px"
    //borderRadius: "0 5px 5px 5px",
  };
  const scrollingBoxStyle = {
    height: "50px",
    backgroundColor: "#f2f2f2",
    border: '2px solid #1851A3',
    overflowX: "scroll",
    whiteSpace: "nowrap",
    padding: "10px",
    position: "fixed",
    // top: "70%",
    left: "0",
    right: "0",
    transform: `translateY(-60%)`,
    bottom: "0",  // Position it at the bottom of the screen
    zIndex: "999",  // Ensure it stays on top of other content
  };

  const handleExcessFreeWindow = () => {
    props.handleChangeValue('excessFreeWindow', !props.inputValues.excessFreeWindow);
  }

  const handleButtonClick = (amount) => {
    props.handleChangeValue('excess', amount - 500);
  };

  const handleVehicleValueUpdate = (event) => {
    const newVehicleValue = event.target.value;
    setVehicleValue(newVehicleValue);
    setErrorMessage("");
    setIsValueButtonEnabled(event.target.value !== vehicleValue);
  };

  const updateVehicleValue = () => {
    const minValue = props.inputValues.vehicleMinValue;
    const maxValue = props.inputValues.vehicleMaxValue;
    const currentValue = parseFloat(vehicleValue);
    // Check if the value is within the specified range
    if (currentValue < minValue || currentValue > maxValue) {
      setErrorMessage("We would expect your car’s value to be between $" + minValue.toLocaleString() + " and $" + maxValue.toLocaleString());
    } else if (currentValue > 150000) {
      setErrorMessage("Sorry, We are unable to offer insurance for your car");
    } else {
      setErrorMessage("");
      props.handleChangeValue("vehicleValue", vehicleValue);
    }
  }

  const buttonStyle = {
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    padding: '0',
    outline: 'none'
  };

  const handleFrequencyUpdate = (event) => {
    props.handleChangeValue('paymentFrequency', event.target.name);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Select Payment Frequency',
        'categoryDetails': event.target.name,
        'virtualUrl': `${baseUrl}/vehicle/step3`,
        'pageTitle': 'Quote',
      });
    }

  const handleReadMoreClick = (event) => {
    event.preventDefault(); // Prevent the default behavior of the anchor element
    setAdditionalPopUpShow(true); // Set additionalPopUpShow to true when "Read more" is clicked
  };

  return (
    <>
      {/*<div className="lg-no-display" style={scrollingBoxStyle}>
              <span style={{...boldTextStyles, color: "#0C2F63"}}>Third Party Fire Theft </span>
                <span style={{...regularTextStyles,color:"#0C2F63"}}>$
                    {props.inputValues.paymentFrequency === "ANNUAL" ? new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).format(props.responseJson.data.attributes.policyComponent.premium.grossPremium) : new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }).format(props.responseJson.data.attributes.policyComponent.premium.installmentAmount)}
                    {' '}{props.inputValues.paymentFrequency.toLowerCase()}</span>
            </div>*/}

      <div style={containerStyle}>
        <div style={{display: "flex", flexDirection: "column"}}>
          <div>
            <div style={{color: '#1851A3', fontWeight: "700px"}}>
              <br/>
              <span style={{fontSize: "40px",}}>{"$"}
                {props.inputValues.paymentFrequency === "ANNUAL" ? new Intl.NumberFormat('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(props.responseJson.data.attributes.policyComponent.premium.grossPremium) : new Intl.NumberFormat('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).format(props.responseJson.data.attributes.policyComponent.premium.installmentAmount)}
                        </span>
              <div>
                            <span style={{flexDirection: "column", fontSize: "20px"}}>
                                <span>{props.inputValues.paymentFrequency === "ANNUAL" ? "yearly" : props.inputValues.paymentFrequency == "FORTNIGHTLY" ? "fortnightly" : "monthly"}</span>
                            </span>
              </div>
            </div>
          </div>
          <br/>
          <div style={boldTextStyles}>Covers your car for loss or damage caused by fire, theft and your
            liability for damage to other people’s property and for bodily injury.
          </div>
          <p style={{...regularTextStyles, paddingTop: "10px"}}>The most we will pay for any one event is the
            lesser of the market value of your car or the amount covered on your policy schedule.
          </p>
          <ul style={{paddingTop: "20px", listStyleType: "none", paddingLeft: "0"}}>
            <div style={regularTextStyles}>
              <li><CrossIcon/> <span style={{paddingLeft: "10px"}}>Accidental damage to your car</span>
              </li>
              <li><CheckIcon/> <span style={{paddingLeft: "10px"}}>Theft of your car</span></li>
              <li><CheckIcon/> <span style={{paddingLeft: "10px"}}>Fire damage to your car</span></li>
              <li><CheckIcon/> <span style={{paddingLeft: "10px"}}>Towing and car storage costs</span>
              </li>
              <li><CheckIcon/> <span style={{paddingLeft: "10px"}}>Damage to your car by an uninsured third party</span>
              </li>
              <li><CheckIcon/> <span style={{paddingLeft: "10px"}}>Your liability for damage to someone else’s car or property (up to $20 million)</span>
              </li>
              <li><CheckIcon/> <span style={{paddingLeft: "10px"}}>Your liability for bodily injury to someone else (up to $1 million)</span>
              </li>
              <li style={{paddingTop: "15px"}}><DownloadIcon/> <span style={{paddingLeft: "10px"}}>
                For full details of cover and exclusions, please download and review the <a
                href="https://docs.autosure.co.nz/policy_books/autosure/car/tpft.pdf"
                target="_blank" rel="noopener noreferrer">policy wording.</a></span></li>
            </div>
          </ul>
        </div>
      </div>
      <div style={{paddingTop: "50px", paddingBottom: "10px"}}>
                <span
                  style={regularTextStyles}>Select your payment frequency (you can pay less if you pay annually)</span>
      </div>
      <div className="sm-display-center " style={{display: "flex", flexDirection: "column"}}>
        <div className="column-on-mobile" style={{display: "flex", gap: "20px"}}>
          <button
            className="sm-button-style lg-button-style"
            style={{
              wordWrap: "break-word",
              borderRadius: 50,
              top: "2px",
              position: "relative",
              overflow: "hidden",
              justifyContent: "center",
              alignItems: "center",
              display: "inline-flex",
              cursor: "pointer",
              border: "1px solid #D1D5DB",
              backgroundColor: props.inputValues.paymentFrequency === "FORTNIGHTLY" ? "#4B5563" : "white",
              color: props.inputValues.paymentFrequency === "FORTNIGHTLY" ? "white" : "black"
            }} name="FORTNIGHTLY" onClick={handleFrequencyUpdate}>Fortnightly
          </button>
          <button
            className="sm-button-style lg-button-style"
            style={{
              wordWrap: "break-word",
              top: "2px",
              position: "relative",
              overflow: "hidden",
              justifyContent: "center",
              alignItems: "center",
              display: "inline-flex",
              cursor: "pointer",
              border: "1px solid #D1D5DB",
              backgroundColor: props.inputValues.paymentFrequency === "MONTHLY" ? "#4B5563" : "white",
              color: props.inputValues.paymentFrequency === "MONTHLY" ? "white" : "black"
            }} name="MONTHLY" onClick={handleFrequencyUpdate}>Monthly
          </button>
          <button
            className="sm-button-style lg-button-style"
            style={{
              wordWrap: "break-word",
              top: "2px",
              position: "relative",
              overflow: "hidden",
              justifyContent: "center",
              alignItems: "center",
              display: "inline-flex",
              cursor: "pointer",
              border: "1px solid #D1D5DB",
              backgroundColor: props.inputValues.paymentFrequency === "ANNUAL" ? "#4B5563" : "white",
              color: props.inputValues.paymentFrequency === "ANNUAL" ? "white" : "black"
            }}
            name="ANNUAL" onClick={handleFrequencyUpdate}>Annual
          </button>
        </div>
        {props.inputValues.paymentFrequency === 'ANNUAL' && (
          <div
            style={{marginTop: '10px', color: '#4B5563', fontStyle: 'italic'}}>
            Please note, annual payment can only be paid by credit/debit card.
          </div>
        )}
      </div>
      <div style={{paddingTop: "50px", paddingBottom: "10px"}}>
        <span style={regularTextStyles}> Standard Excess</span>
      </div>
      <div className="sm-button-style lg-button-style" style={{display: "flex", gap: "20px", width: "100%"}}>
        {[500].map((amount) => (
          <button
            key={amount}
            disabled={true}
            style={{
              wordWrap: "break-word",
              backgroundColor: "#4B5563",
              color: "white",
              width: "100%",
              maxWidth: "250px",
              lineHeight: "30px",
              borderRadius: 50,
              top: "2px",
              position: "relative",
              overflow: "hidden",
              justifyContent: "center",
              alignItems: "center",
              display: "inline-flex",
              border: "1px solid #D1D5DB",
            }}
          >
            ${amount}
          </button>
        ))}
      </div>
      <div style={regularTextStyles}>Other excesses may apply. <a href="#" onClick={handleReadMoreClick}>Read more</a>
      </div>
      <AdditionalExcess
        parentContinueOfflinePopupShow={additionalPopUpShow}
        setParentContinueOfflinePopupShow={setAdditionalPopUpShow}
      />
      <div style={{paddingTop: "50px"}}>
                    <span style={regularTextStyles}>
                   Car's value(amount covered)
                    </span>
        <TooltipTFAF
          title={
            <div>
              <span>The current retail value of your car. You can find this out by looking at cars for sale online that are the same make, model, year, condition and mileage as yours.</span><br/><br/>
              Please remember to allow for any additional improvements your car may have e.g. roof racks and tow bars,
              fitted entertainment, communication and navigation systems.
            </div>
          }>
          <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
        </TooltipTFAF>
        <div style={{paddingTop: "10px"}}>
          <input
            className="block w-full rounded-md py-1.5 pl-10 pr-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            style={{
              border: '1px #E5E7EB solid',
              boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
              borderRadius: 6,
              outline: 'none',
              fontSize: 'inherit',
              fontFamily: 'inherit',
              fontWeight: 'inherit',
              lineHeight: 'inherit',
              width: '100%',
              maxWidth: '300px',
              height: '40px',
              marginRight: '10px',
              background: 'transparent',
            }}
            name="vehicleValue"
            // onLoad={props.handleChange}
            type="number"
            pattern="[0-9]*" // Accepts only numbers
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Prevents non-numeric input
            }}
            onChange={handleVehicleValueUpdate}
            maxLength={6}
            required={true}
            defaultValue={vehicleValue}
          />
          <button
            onClick={updateVehicleValue}
            disabled={!isValueButtonEnabled} // Disable the button if the value hasn't changed
            style={{
              background: isValueButtonEnabled ? '#D1D5DB' : '#F3F4F6', // Darker gray when enabled, light gray when disabled
              cursor: isValueButtonEnabled ? 'pointer' : 'not-allowed',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '6px',
              color: isValueButtonEnabled ? '#1F2937' : '#9CA3AF',
              transition: 'background 0.3s ease',
            }}
          >
            <span style={regularTextStyles}>Update car value</span>
          </button>
        </div>
        {/* Display error message if the value is not in range */}
        {errorMessage && <div style={{color: 'red'}}>{errorMessage}</div>}
      </div>
      <div style={{paddingTop: "50px"}}>
                <span
                  style={regularTextStyles}>Select this optional benefit if you would like it.</span>
        <div style={{display: "flex", paddingTop: "5px", alignItems: "flex-start"}}>
          <Form.Check
            type="checkbox"
            id="excess-free-window"
            onChange={handleExcessFreeWindow}
            checked={props.inputValues.excessFreeWindow}
            // label="Excess-free windscreen and window glass replacement"
            className="custom-radio"
            style={{marginRight: "8px"}}
          />
          <div>
            <span>Excess-free windscreen and window glass replacement</span>
          <TooltipTFAF
            title="If you select this and we agree to pay a claim when you are not claiming for any other damage to your car, you won't have to pay an excess if your windscreen or window glass needs replacement.">
            <i className="fa fa-info-circle" style={{color: '#1851A3'}}/>
          </TooltipTFAF>
        </div>
        </div>
      </div>
      <div style={{paddingTop: "50px", paddingBottom: "50px"}}>
        <span style={regularTextStyles}> Select your policy start date</span>
        <div style={{width: '100%', maxWidth: '300px', marginRight: '10px', position: 'relative'}}>
          <DatePicker
            ref={datePickerRef}
            selected={props.inputValues.policyStartDate ? props.inputValues.policyStartDate : new Date()}
            onChange={(date) => props.handleChangeValue('policyStartDate', date)}
            dateFormat="dd/MM/yyyy"
            className="custom-datepicker"
            placeholderText="DD/MM/YYYY"
            minDate={new Date()}
            maxDate={new Date(new Date().setDate(new Date().getDate() + 30))}
          />
          <FaCalendarAlt onClick={handleIconClick}
                         style={{
                           position: 'absolute',
                           right: '20px',
                           top: '50%',
                           transform: 'translateY(-50%)',
                           cursor: 'pointer'
                         }}/>
        </div>

      </div>
      <SaveEmailQuote showEmailPopup={showEmailPopup} setShowEmailPopup={setShowEmailPopup}
                      inputValues={props.inputValues}/>
      <button
        className="btn rounded-md px-4 py-2.5 text-sm font-weight-bold text-gray-900 shadow-sm"
        onClick={saveAndEmailQuote}
        style={{
          color: '#1851A3',
          paddingLeft: 25,
          paddingRight: 25,
          paddingTop: 13,
          paddingBottom: 13,
          background: 'white',
          border: '1px #1851A3 solid',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'inline-flex',
          wordWrap: 'break-word',
          boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
          borderRadius: 6,
          width: "100%",
          maxWidth: "200px"
        }}>
        Email my quote
      </button>
      <div style={{paddingBottom: "150px"}}>
        <p
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: "center",
            paddingTop: '32px'
          }}>
          <button
            className="float-end"
            onClick={() => props.prevStep()}
            style={{
              color: '#1851A3',
              paddingLeft: 25,
              paddingRight: 25,
              paddingTop: 13,
              paddingBottom: 13,
              background: 'white',
              border: '1px #1851A3 solid',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'inline-flex',
              wordWrap: 'break-word',
              boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
              borderRadius: 6,
              width: "100%",
              maxWidth: "200px"
            }}
          >
            Back
          </button>
          <button
            className="float-end"
            style={{
              color: "white",
              paddingLeft: 25,
              paddingRight: 25,
              paddingTop: 13,
              paddingBottom: 13,
              width: "100%",
              maxWidth: "200px",
              background: isValueButtonEnabled ? '#B0C4DE' : '#1851A3',
              boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
              borderRadius: 6,
              overflow: 'hidden',
              border: '1px white solid',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'inline-flex',
              cursor: !isValueButtonEnabled ? 'pointer' : 'not-allowed',
              opacity: 1
            }}
            onClick={handleNextButtonClick}
            disabled={isValueButtonEnabled}

          >
            Next
          </button>
        </p>
      </div>
    </>
  );
};
export default ThirdPartyFireTheft;
